uniform float uTime;
uniform float uDeltaTime;
uniform sampler2D uBase;
uniform vec3 uMouse;
uniform float uMouseRadius;
uniform float uMouseAspect;
uniform float uSuckAmount;
uniform float uMouseTrail;

#include ../includes/simplexNoise4d.glsl

float rectDist(vec3 pos, vec3 center, float radius, float aspect)
{
    vec3 d = abs(pos - center);
    float dx = d.x / (radius * aspect);
    float dy = d.y / (radius / aspect);
    float dz = d.z / radius;
    return max(max(dx, dy), dz);
}

void main()
{
    float time = uTime * 0.2;
    vec2 uv = gl_FragCoord.xy / resolution.xy;
    vec4 particle = texture(uParticles, uv);
    vec4 velocity = texture(uVelocity, uv);
    vec4 base = texture(uBase, uv);

    // Dead
    if(particle.a >= 1.0)
    {
        particle.a = mod(particle.a, 1.0);

        // Some particles spawn from mouse as a smoke trail
        float spawnNoise = simplexNoise4d(vec4(uv * 100.0, time * 5.0, 0.0));
        if(uMouse.x < 9000.0 && uMouseTrail > 0.0 && uSuckAmount < 0.1 && spawnNoise > (1.0 - uMouseTrail))
        {
            vec3 offset = vec3(
                simplexNoise4d(vec4(uv * 50.0, time * 10.0, 1.0)),
                simplexNoise4d(vec4(uv * 50.0, time * 10.0, 2.0)),
                simplexNoise4d(vec4(uv * 50.0, time * 10.0, 3.0))
            ) * 0.3;
            particle.xyz = uMouse + offset;
        }
        else
        {
            particle.xyz = base.xyz;
        }
    }

    // Alive
    else
    {
        // Apply velocity
        particle.xyz += velocity.xyz * uDeltaTime;

        // Fade out near mouse when sucking
        if(uSuckAmount > 0.01)
        {
            float rd = rectDist(particle.xyz, uMouse, uMouseRadius, uMouseAspect);
            float fadezone = smoothstep(0.5, 0.15, rd);
            particle.a += fadezone * uDeltaTime * 5.0;
        }

        // Decay
        particle.a += uDeltaTime * 0.3;
    }

    gl_FragColor = particle;
}
